import type { CityConfig } from "../city-template/types";

export const flintConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Genesee County Clerk", href: "https://www.gc4me.com/clerk", description: "Genesee County Clerk — marriage license issuance" },
    { label: "Divorce Records — Genesee County Clerk", href: "https://www.gc4me.com/clerk", description: "Genesee County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Flint",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "flint",
  route: "/cities/flint",
  title: "Emergency Passport Flint, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Flint, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Flint, Burton, Grand Blanc, Fenton, Davison, and all Genesee County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Flint, MI",
  heroSubtitle: "Flint travelers — from Genesee County families to auto industry professionals to Bishop International flyers — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Mid-Michigan and the Flint-Saginaw corridor.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Flint%20Michigan%20downtown%20along%20the%20Flint%20River%20with%20modern%20cityscape%2C%20historic%20buildings%2C%20the%20University%20of%20Michigan%20Flint%20campus%20visible%2C%20green%20riverbanks%20with%20trees%2C%20bright%20afternoon%20sunlight%20casting%20warm%20golden%20tones%20across%20the%20urban%20landscape%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=flint-hero-002&orientation=landscape",
  heroImageAlt: "Flint Michigan downtown skyline along the Flint River with historic architecture and modern cityscape",
  geoPosition: "43.0125;-83.6874",
  geoPlacename: "Flint, Michigan",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 285 miles, 4 hours via I-69",
  },
  nearbyCitiesZips: [
    { name: "Flint", zips: "48501, 48502, 48503, 48504, 48505, 48506, 48507, 48532, 48550, 48551, 48553, 48554, 48555, 48557" },
    { name: "Burton", zips: "48509, 48519, 48529" },
    { name: "Grand Blanc", zips: "48439, 48480" },
    { name: "Fenton", zips: "48430" },
    { name: "Davison", zips: "48423" },
    { name: "Swartz Creek", zips: "48473" },
    { name: "Flushing", zips: "48433" },
    { name: "Mount Morris", zips: "48458" },
    { name: "Linden", zips: "48451" },
    { name: "Goodrich", zips: "48438" },
    { name: "Holly", zips: "48442" },
    { name: "Clio", zips: "48420" },
    { name: "Saginaw", zips: "48601, 48602, 48603, 48604, 48605, 48607, 48638" },
    { name: "Bay City", zips: "48706, 48707, 48708" },
    { name: "Midland", zips: "48640, 48641, 48642, 48667, 48670, 48674, 48686" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Detroit Passport Agency — no 1-hour drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-plane-line", title: "FNT Airport Focus", desc: "Bishop International travelers — direct flights to Florida, Vegas, Chicago" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no road trip to Detroit" },
  ],
  internalLinks: [
    { name: "Expedited passport in Grand Blanc, MI", route: "/michigan" },
    { name: "Emergency passport help in Saginaw, MI", route: "/michigan" },
    { name: "Urgent passport services in Midland, MI", route: "/michigan" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Flint, Michigan remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (285 miles, 4 hours via I-69) — without you making the drive. Flint residents can ship from any UPS or FedEx in Genesee County.",
  fpcOfficeDistance: "Serving Flint, Burton, Grand Blanc, Fenton, Davison, Swartz Creek, Flushing, Mount Morris, Linden, Clio, and all of Genesee County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Flint and the greater Genesee County area. From downtown Flint along the Flint River to the northern suburbs of Grand Blanc and Fenton, from the Saginaw Bay corridor to the western communities of Flushing and Swartz Creek — we serve all of Mid-Michigan.",
  nearbyCitiesIntro: "We serve Flint and all Genesee County communities including Burton, Grand Blanc, Fenton, Davison, Swartz Creek, Flushing, Mount Morris, Linden, Goodrich, Holly, and Clio. We also serve the Saginaw Bay region including Saginaw, Bay City, and Midland.",
  howItWorksIntro: "Most Flint travelers complete everything online and ship documents overnight. No need to drive an hour to the Detroit Passport Agency — our couriers handle the submission for you.",
  mistakesIntro: "Flint is a major Mid-Michigan hub with a large auto industry heritage and strong international travel demand. Here are the most common passport mistakes we see from Genesee County travelers.",
  testimonialsIntro: "Flint travelers — from Bishop International flyers to auto industry families to college students — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Flint, MI? Here are the most common ones we hear from Genesee County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct courier to Detroit Passport Agency", "No long drive required", "Perfect for FNT airport travelers", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct courier to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 1 hour to Detroit via I-75", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Flint travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute FNT airport departures and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "FNT airport and international travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Flint adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Genesee County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Flint residents and families — including college students, new citizens, and Genesee County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Flint residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Flint and Genesee County families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Flint and Genesee County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Flint MI", description: "Urgent passport processing for Flint Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Flint MI", description: "Fast passport renewal for Flint Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Flint MI", description: "New passport application services for Flint Michigan residents applying for their first passport." },
    { name: "Child Passport Flint MI", description: "Minor passport services for Flint Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Angela M.",
      location: "Flint, MI",
      rating: 5,
      text: "Cruise leaving from Miami in 5 days and my passport was expired. Fast Passport Center had my renewed passport in 36 hours. I shipped from the UPS Store on Miller Road and never had to drive to Detroit. Amazing.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Robert T.",
      location: "Grand Blanc, MI",
      rating: 5,
      text: "Family trip to Cancun with 9 days notice. Five passports for our whole family. Done in 6 days. The process was completely online — we just shipped everything and waited. Incredible service.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jasmine K.",
      location: "Burton, MI",
      rating: 5,
      text: "Lost my passport the week before a business trip to London. Fast Passport Center replaced it in 48 hours. I shipped from FedEx on Bristol Road and it was back in my hands before my flight.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Carlos D.",
      location: "Fenton, MI",
      rating: 5,
      text: "First-time passport for a mission trip to Guatemala. Fast Passport Center walked me through the entire DS-11 process and had my passport ready in 7 days. Very professional and responsive.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "flint-1",
      name: "Flint Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "250 E Boulevard Dr",
      city: "Flint",
      state: "MI",
      zip: "48502",
      phone: "(810) 232-3802",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Flint, near the Flint River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Flint acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers and University of Michigan Flint students.",
      icon: "ri-mail-line",
    },
    {
      id: "flint-2",
      name: "Grand Blanc Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "135 E Grand Blanc Rd",
      city: "Grand Blanc",
      state: "MI",
      zip: "48439",
      phone: "(810) 694-2832",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Grand Blanc, approximately 8 miles south of downtown Flint",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Grand Blanc, Holly, and southern Genesee County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "flint-3",
      name: "Fenton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "140 N Leroy St",
      city: "Fenton",
      state: "MI",
      zip: "48430",
      phone: "(810) 629-4514",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fenton, approximately 12 miles south of downtown Flint",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fenton, Linden, and southern Genesee County communities. Good alternative when downtown Flint is fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "flint-4",
      name: "Burton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4201 S Saginaw St",
      city: "Burton",
      state: "MI",
      zip: "48529",
      phone: "(810) 743-7070",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Burton, approximately 4 miles south of downtown Flint",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Burton, Swartz Creek, and southeast Flint residents.",
      icon: "ri-mail-line",
    },
    {
      id: "flint-5",
      name: "Davison Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 N Main St",
      city: "Davison",
      state: "MI",
      zip: "48423",
      phone: "(810) 653-3834",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Davison, approximately 10 miles east of downtown Flint",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davison, Lapeer, and eastern Genesee County communities.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 285-mile drive to Chicago via I-69", fpc: "No — ship from Flint" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "FNT Airport Focus", agency: "No tailored advice", fpc: "Yes — Bishop International travel expertise" },
    { feature: "Genesee County Coverage", agency: "No local knowledge", fpc: "Yes — serving all of Mid-Michigan" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Flint-area travelers often discover passport issues right before FNT departures. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Miller Road or Hill Road sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Genesee County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Flint-area Post Office appointments fill during summer and spring break travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Detroit",
      description: "Many Flint residents attempt to drive to the Detroit Passport Agency in an emergency. The 1-hour drive each way plus parking and wait time means a full day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Winter Caribbean travel from FNT peaks January–March — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Genesee County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Miller Road, Hill Road, or downtown Flint." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Flint-area address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Flint, MI?", a: "Fast Passport Center offers emergency passport processing in Flint, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (1 hour south via I-75) — without you making the drive." },
    { q: "Does Flint have its own passport agency?", a: "No — Flint does not have a regional passport agency. The nearest facility is the Detroit Passport Agency at 477 Michigan Ave 3rd Floor, Detroit, MI 48226 (approximately 1 hour south via I-75). Fast Passport Center's courier service means Flint residents never need to make the drive." },
    { q: "Can I get an expedited passport in Grand Blanc, Fenton, or Burton?", a: "Absolutely. Fast Passport Center serves all of Genesee County including Grand Blanc, Fenton, Burton, Davison, Swartz Creek, Flushing, Mount Morris, Linden, Holly, Clio, and all surrounding communities. Our service works the same way everywhere." },
    { q: "What airport do Flint travelers use for international flights?", a: "Bishop International Airport (FNT) is the primary airport for Flint and Genesee County. FNT offers direct flights to Orlando, Tampa, Las Vegas, Chicago, and seasonal Caribbean destinations. Most international flights connect through Chicago O'Hare (ORD), Detroit (DTW), or Atlanta (ATL). Always verify passport validity for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Flint, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Flint?", a: "Walgreens, CVS, and Meijer stores throughout Flint and Genesee County offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Saginaw and Bay City?", a: "Yes. Fast Passport Center serves all of Mid-Michigan including Saginaw, Bay City, Midland, and the entire Great Lakes Bay region. Our courier service reaches every corner of Central and Eastern Michigan." },
    { q: "Can I upgrade my processing speed after I submit?", a: "If you submit through a post office or directly to the government, no — you cannot upgrade speed after submission. With Fast Passport Center, you can upgrade your processing speed at any point before your documents are submitted to the agency. That's a major advantage of our service." },
  ],
  photoLocations: [
    { name: "Meijer — Hill Road Flint", address: "4519 Hill Rd, Flint, MI 48507", hours: "Mon–Sun: 6AM–Midnight", website: "https://www.meijer.com/store-locator" },
    { name: "Walgreens — Miller Road Flint", address: "G-4085 Miller Rd, Flint, MI 48507", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "UPS Store — Grand Blanc", address: "12725 S Saginaw St, Grand Blanc, MI 48439", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "FedEx Office — Fenton", address: "3100 Owen Rd, Fenton, MI 48430", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Flint", address: "302 E Kearsley St, Flint, MI 48502", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended.", featured: true },
    { name: "Michigan SOS — Grand Blanc", address: "G-4085 Miller Rd, Flint, MI 48507", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Grand Blanc, southern Genesee County, and Holly area. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "FNT",
      name: "Bishop International Airport",
      distance: "4 miles northwest of downtown Flint via I-69",
      address: "3425 W Bristol Rd, Flint, MI 48507",
      note: "Primary airport for Flint and Genesee County. Direct flights to Orlando, Tampa, Las Vegas, Chicago, and seasonal Caribbean destinations. Most international travel connects through Chicago O'Hare (ORD), Detroit (DTW), or Atlanta (ATL).",
      flightUrl: "https://www.bishopairport.org/",
      flightLabel: "FNT Flight Info",
      featured: true,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 1 hour south of Flint via I-75",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Larger international hub for Flint travelers needing direct international flights. Delta hub with direct routes to Europe, Asia, and Latin America.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3.5 hours southwest of Flint via I-69 and I-80",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major hub for Genesee County travelers seeking more international routes. United and American Airlines hub with global connections.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
};